// frontend/src/pages/ProjectCapex.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";  
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";

export default function ProjectProduction() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;
  
  return (
    <form className="max-w-md space-y-8 text-xs">

      <div className="space-y-2">
        <ProjectInputField label={t("project.capex.relative_costs")} name="relative_costs" value={formData.relative_costs} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label={t("project.capex.inverter_replacement_costs")} name="inverter_replacement_costs" value={formData.inverter_replacement_costs} type={getFieldType("inverter_replacement_costs")} onChange={handleChange} />
        <ProjectInputField label={t("project.capex.inverter_lifetime")} name="inverter_lifetime" value={formData.inverter_lifetime} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}